import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { PICK_BATCH_QUEUE } from './constants';

const messages = defineMessages({
  pickBatchQueue: {
    description: 'Label for the pick batch queue filter',
    defaultMessage: 'Queued',
    id: 'h8SmNG',
  },
});

export const pickBatchQueueFilterArgument = {
  id: 'option-pickBatch',
  displayName: <FormattedMessage {...messages.pickBatchQueue} />,
  value: PICK_BATCH_QUEUE,
};
